import React, { useState, ReactNode } from 'react';
import * as yup from 'yup';

import { FormContextProvider } from './form-context';

interface IFormProps {
    initialValues: any;
    schema: yup.Schema<any>;
    onSubmit?: (values: any, reset?: () => void) => void;
    render(obj: IFormStatus): ReactNode;
}

interface IFormStatus {
    valid: boolean;
    submitted: boolean;
    values: any;
}

const Form = ({ initialValues, onSubmit, schema, render }: IFormProps) => {
    const [values, updateValues] = useState({ ...initialValues });
    const [submitted, setSubmitted] = useState(false);

    const onSubmitForm = (event: React.FormEvent) => {
        event.preventDefault();

        setSubmitted(true);

        if (schema.isValidSync(values)) {
            onSubmit(values, () => updateValues(initialValues));
        }
    }

    return (
        <FormContextProvider value={{
            values,
            updateValues,
            submitted,
            schema,
        }}>
            <form onSubmit={onSubmitForm} noValidate>
                {render({ valid: schema.isValidSync(values), values, submitted })}
            </form>
        </FormContextProvider>
    )
}

export default Form;
